import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AuthModal from "@/components/AuthModal";
import { toast } from "sonner";
import { Flag } from "lucide-react";

const REASONS = [
  ["spam", "Spam"], ["harassment", "Harassment"], ["hate_abuse", "Hate / abuse"],
  ["impersonation", "Impersonation"], ["illegal", "Illegal content"],
  ["personal_info", "Personal information"], ["threats", "Threats"],
  ["manipulation", "Manipulation"], ["other", "Other"],
];

export default function ReportButton({ targetType, targetId, label = "Report" }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);

  const send = async (reason) => {
    try {
      await api.post("/reports", { target_type: targetType, target_id: targetId, reason });
      toast.success("Reported. Our team will review it.");
      setOpen(false);
    } catch { toast.error("Could not report"); }
  };

  return (
    <>
      <button data-testid="report-btn" onClick={() => (user ? setOpen(true) : setAuthOpen(true))}
        className="text-xs text-muted-foreground hover:text-missed flex items-center gap-1">
        <Flag className="w-3.5 h-3.5" /> {label}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="card-brutal border-2 border-ink sm:max-w-sm" data-testid="report-dialog">
          <DialogHeader><DialogTitle className="font-display text-xl font-bold">Report this {targetType}</DialogTitle></DialogHeader>
          <div className="grid grid-cols-2 gap-2">
            {REASONS.map(([id, l]) => (
              <button key={id} data-testid={`report-reason-${id}`} onClick={() => send(id)}
                className="h-10 border-2 border-ink bg-white text-sm font-semibold btn-press shadow-brutal-sm hover:bg-locked">{l}</button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
      <AuthModal open={authOpen} onOpenChange={setAuthOpen} title="Sign in to report" />
    </>
  );
}
